export enum LayerItemId {
    PLOTS = "59feccc8-a191-489d-b144-fcbc854b78b3",
    HELP = "a98ef62a-32a9-4892-be90-789502b3003c",
}